import createUserApi from '@/api/post/create-user';
import Alert from '@/components/alert/alert-component';
import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { useMutation } from '@/hooks/use-api';
import { useNavigate } from 'react-router-dom';
import UserForm from './user-form';
import Styled from './user-new-style';

/**
 * create new user
 * @returns {JSX.Element}
 */
const UserNew = () => {
  const navigate = useNavigate();

  const [createUser, { loading: createUserLoading }] =
    useMutation(createUserApi);

  return (
    <Styled.Main>
      <FormWrapper
        defaultValues={{
          status: 'new',
        }}
        onSubmit={(submitValues) =>
          createUser(submitValues).then(() => {
            navigate('/app/user-management');
            Alert({
              icon: 'success',
              text: 'User created successfully',
            });
          })
        }
      >
        <UserForm isLoading={false} />
        <SubmitCard
          padding="0"
          primaryButtonTitle="Save"
          primaryButtonType="submit"
          primaryButtonDisabled={false}
          primaryButtonWidth="112px"
          secondaryButtonType="button"
          secondaryButtonDisabled={false}
          secondaryButtonWidth="112px"
          isLoading={createUserLoading}
          secondaryButtonTitle="Cancel"
          submitClickSecondary={() => {
            navigate(`/app/user-management/users`);
          }}
        />
      </FormWrapper>
    </Styled.Main>
  );
};
export default UserNew;
